var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFiat = function SvgFiat(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9995 18V17H7.99854V15H13.9995V12.999H8.99854C8.44654 12.999 7.99854 12.552 7.99854 11.999V7.99902C7.99854 7.44602 8.44654 6.99902 8.99854 6.99902H10.9995V5.99902H12.9995V6.99902H15.9995V8.99902H9.99854V10.999H14.9995C15.5525 10.999 15.9995 11.447 15.9995 11.999V16C15.9995 16.553 15.5525 17 14.9995 17H12.9995V18H10.9995Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 2C6.47751 2 1.99951 6.478 1.99951 12C1.99951 17.522 6.47751 22 11.9995 22C17.5225 22 21.9995 17.522 21.9995 12C21.9995 6.478 17.5225 2 11.9995 2ZM11.9995 4C16.4105 4 19.9995 7.589 19.9995 12C19.9995 16.411 16.4105 20 11.9995 20C7.58851 20 3.99951 16.411 3.99951 12C3.99951 7.589 7.58851 4 11.9995 4Z",
    fill: "currentColor"
  })));
};
export default SvgFiat;